module.exports = __webpack_public_path__ + "img/6fbd24b.webp";